import { Link } from '@/components';

import { tokensMappingArbitrum } from '@/utils/tokens';
import {
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  Heading,
  RelativeDateTime,
  WalletAddress
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function TokenEventsTable({ pagination, data, sorting }) {
  const columns: TableColumn[] = [
    {
      header: 'Wallet Address',
      getCell: (row) => (
        <Link to={`/arbitrum/psm3/depositors/${row.wallet_address}`}>
          <WalletAddress
            address={row.wallet_address}
            options={{ sizes: { blockie: '0' } }}
          />
        </Link>
      )
    },
    {
      header: 'Event',
      getCell: (row) => row.event
    },
    {
      header: (
        <Flex display="flex" flexDirection="row" alignItems="center" gap="3xs">
          Amount
        </Flex>
      ),
      getCell: (row) => (
        <CurrencyValue
          value={row.assets}
          options={{
            currency: tokensMappingArbitrum(row.asset_symbol),
            trend: true,
            iconSize: '1',
            trendIcon: false
          }}
        />
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'assets'
    },
    {
      header: 'Time',
      getCell: (row) => (
        <Flex gap={['xs', '2xs']} color="muted">
          <RelativeDateTime value={row.datetime} />
          <a
            href={`https://arbiscan.io/tx/${row.tx_hash}`}
            target="_blank"
            rel="noreferrer">
            <EtherScanPictogram size="0" />
          </a>
        </Flex>
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'order_index'
    }
  ];

  return (
    <>
      <Flex justifyContent="space-between">
        <Heading size="2">Events</Heading>
      </Flex>
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index + row.wallet_address}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    </>
  );
}
